import React from "react";
import {
  Gem, Eye, Crown, Fingerprint, Headphones, Magnet, Layers, Coins, Landmark, Pin,
  Lightbulb, Repeat, Megaphone, PhoneCall, ShieldCheck, MessagesSquare, ChartColumn, Sparkles, Lock,
} from "lucide-react";

const Svg = ({ size, children, sw = 1.9 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round">{children}</svg>
);

const Robot = ({ size }) => (
  <Svg size={size}>
    <path d="M12 6V3.5" /><circle cx="12" cy="2.6" r="1" fill="currentColor" />
    <rect x="4" y="6" width="16" height="12.5" rx="4.5" />
    <circle cx="9" cy="11.6" r="1.4" fill="currentColor" stroke="none" /><circle cx="15" cy="11.6" r="1.4" fill="currentColor" stroke="none" />
    <path d="M9.8 15.1c1.3.9 3.1.9 4.4 0" /><path d="M2 10.5v4" /><path d="M22 10.5v4" /><path d="M9 21.5h6" />
  </Svg>
);

const Woman = ({ size }) => (
  <Svg size={Math.round(size * 1.15)} sw={2}>
    <path d="M7 14.6c-1-1.2-1.5-3-1.5-4.9C5.5 6.2 8.4 3.5 12 3.5s6.5 2.7 6.5 6.2c0 1.9-.5 3.7-1.5 4.9" />
    <ellipse cx="12" cy="10.6" rx="3.4" ry="3.9" />
    <path d="M8.7 8.9c2 .1 4.6-.6 6.1-2.5" />
    <path d="M4.5 21c.6-3.4 3.8-5.6 7.5-5.6s6.9 2.2 7.5 5.6" />
  </Svg>
);

const MoneyBag = ({ size }) => (
  <Svg size={Math.round(size * 1.25)} sw={2.2}>
    <path d="M8.5 2.5h7L13.6 6h-3.2z" />
    <path d="M10 6.2C5.8 8.4 3.5 12.6 3.5 16.2c0 3 2.2 5.3 5.3 5.3h6.4c3.1 0 5.3-2.3 5.3-5.3 0-3.6-2.3-7.8-6.5-10" />
    <text x="12" y="18.6" textAnchor="middle" fontSize="10.5" fontWeight="700" fill="currentColor" stroke="none" fontFamily="Arial, sans-serif">€</text>
  </Svg>
);


const ICONS = {
  "the-success-foundations": Gem, direction: Eye, cible: Woman, positionnement: Crown, identite: Fingerprint,
  "capsules-audio": Headphones, "capsules-audio-abondance": Headphones, "capsules-audio-contenu": Headphones, "capsules-audio-phase2": Headphones,
  "prompt-cible": Robot, "prompt-methode": Robot, "prompt-adapter": Robot,
  "strategie-contenu": Magnet, "resume-strategie-organique": Layers, "methode-3c": Coins, "piliers-contenu": Landmark,
  "ressources-story": Pin, "banque-idees": Lightbulb, "adapter-contenu": Repeat, accroches: Megaphone, manychat: Robot,
  "strategie-vente": MoneyBag, "trame-appel": PhoneCall, "repondre-objections": ShieldCheck, "process-setting": MessagesSquare,
  "analyse-contenus": ChartColumn,
  "audit-direction": Eye, "audit-cible": Woman, "audit-offres": MoneyBag,
};

const SIZES = { sm: ["h-8 w-8 rounded-lg", 15], md: ["h-11 w-11 rounded-xl", 19], lg: ["h-14 w-14 rounded-2xl", 24] };

export const ProgIcon = ({ slug, size = "md", locked = false, tint = false }) => {
  const Icon = locked ? Lock : ICONS[slug] || Sparkles;
  const [box, px] = SIZES[size];
  return (
    <span
      data-testid={`prog-icon-${slug}`}
      className={`flex shrink-0 items-center justify-center ${box} ${locked ? "bg-cream text-ink-muted ring-1 ring-line" : tint ? "bg-bordeaux-tint text-bordeaux" : "bg-bordeaux text-white shadow-[0_8px_24px_rgba(123,17,58,0.35)]"}`}
    >
      <Icon size={px} />
    </span>
  );
};
